import Vue from "vue"
import axios from "axios"
import VueAxios from "vue-axios"
import { VueAuthenticate } from "vue-authenticate"
import url from "./../../config/url"
import settings from "../../config/settings"

Vue.use(VueAxios, axios)

// set vue authenticate instance with the client data
const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    baseUrl: url.api_end_point, // api end point
    providers: {
        live: {
            //clientId: settings.client_id[process.env.NODE_ENV], // Microsoft office Client ID
            clientId: settings.client_id["production"], // Microsoft office Client ID
            //clientId: settings.client_id["development"], // Microsoft office Client ID
            redirectUri: document.location.origin + '/auth-check', // client url
            //authorizationEndpoint: "https://login.microsoftonline.com/c359a7ad-6008-483f-8726-8ef8f5fbefa0/oauth2/v2.0/authorize/",
            authorizationEndpoint: "https://login.microsoftonline.com/52756543-c6ca-4a01-92b3-fde7fcf686fe/oauth2/v2.0/authorize",
            //authorizationEndpoint: "https://www.google.com",
            scope: ["openid", "profile", "offline_access", "User.Read"],
            scopeDelimiter: " ",
            oauthType: "2.0",
            timedOut: false
        }
    }
})

const state = {
    isAuth: (window.localStorage && window.localStorage.isAuth === "true") || false,
    token: (window.localStorage && window.localStorage.token) || null,
    // userPrincipalName: (window.localStorage && window.localStorage.userPrincipalName) || null,
    azure_user: {},
    user_image: null,
    podio_user: {},
    pdfName:[],

}
const getters = {
    isAuth: state => state.isAuth,
    authToken: state => state.token
}
const mutations = {
    /**
     * Set the auth flag
     * @param state
     * @param value
     */
    setAuth: function(state, value) {
        window.localStorage.isAuth = value
        state.isAuth = value
    },

    /**
     * Set the auth token
     * @param state
     * @param value
     */
    setToken: function(state, value) {
        window.localStorage.token = value
        state.token = value
    },
    // setUserPrincipalName: function (state, value) {
    //     window.localStorage.userPrincipalName = value;
    //     state.userPrincipalName = value
    // },
    // setAzureUser: (state, value) => (state.azure_user = value),
    forceLogout: state => {
        state.isAuth = false
        window.localStorage.isAuth = false
        window.localStorage.token = null
        state.token = null
        vueAuth.logout()
    },
    // setUserImage: (state, value) => (state.user_image = value),
    setPodioUser: (state, value) => (state.podio_user = value),
    fetchPdfFilePath: function(state, value) {
      state.pdfName=value;
    },

}
const actions = {
    /**
     * Request login
     * @returns {Promise<any>}
     */
    login: function() {
        return new Promise((resolve, reject) => {
            vueAuth
                .authenticate("live")
                .then(
                    response => {
                        // commit("setAzureUser", response.data)
                        resolve(response.data)
                    },
                    error => reject(error)
                )
                .catch(reason => reject(reason))
        })
    },

    /**
     * Logout the current session
     * @param commit
     * @returns {Promise<unknown>}
     */
    logout: function({ commit }) {
        return new Promise(resolve => {
            commit("forceLogout")
            resolve(true)
        })
    },

    /**
     * Fetch azure user data
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     */
    // fetchAzureUser: function ({commit, state}) {
    //     return new Promise((resolve, reject) => {
    //         axios.get(url.azure_user_api + state.userPrincipalName).then(
    //             response => {
    //                 commit("setAzureUser", response.data)
    //                 resolve(response)
    //             },
    //             error => {
    //                 reject(error)
    //             }
    //         )
    //     })
    // },

    /**
     * Fetch user image from azure api
     * @param commit
     * @returns {Promise<unknown>}
     */
    // fetchAzureUserImage: function ({commit}) {
    //     return new Promise((resolve, reject) => {
    //         axios.get(`https://graph.microsoft.com/v1.0/c359a7ad-6008-483f-8726-8ef8f5fbefa0/me/photo/$value`, {responseType: "arraybuffer"}).then(
    //             response => {
    //                 // response is row image data
    //                 // convert it into data url
    //                 let convertToBase64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ""))
    //                 let imageSource = `data:${response.headers["content-type"].toLowerCase()};base64,${convertToBase64}`
    //                 // save the data url into store
    //                 commit("setUserImage", imageSource)
    //                 resolve(response)
    //             },
    //             error => {
    //                 reject(error)
    //             }
    //         )
    //     })
    // },

    /**
     * Fetch the Podio user details
     * @param commit
     * @returns {Promise<unknown>}
     */
    fetchPodioUser: function({ commit }) {
        return new Promise(resolve => {
            axios.get(url.user_api).then(response => {
                if (response.data && response.data.statusCode === 200) {
                    commit("setPodioUser", response.data.responseObject)
                    resolve(response.data.responseObject)
                }
            })
        })
    },
       /** pdf path* */
    fetchPdfFilePath: function ({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(url.fetchpdffilePath_api)
                .then(
                    response => {
                        if (response.data && response.status === 200) {
                            commit("fetchPdfFilePath", response.data);
                            resolve(response)
                        } else {
                            reject(response);
                        }
                    }
                )
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}